import { AxiosRequest } from "../../../Url";
import { defaultFieldInfo, getRightsData } from "../../Tools/Tools";
import { createGrid, createRecordSource, mfDelete, mfEdit, mfInsert } from "../rcsgrid";
import { getParamColumnsOptions, ParsedColumn } from "../GridTools/parseColumnTools";
import { EditStyle, ParamSetOption, Prefixes } from "../../Tools/ProjectX";
import { ObjType } from "../../Tools/Consts";
import smetaAxios from "../../../SmetaAxios";
import { getDialogParams, getParamObjectValues } from "../../Tools/Requests";
import { RefObject } from "react";
import { HTMLGridTableCellElement, HTMLGridTableElement } from "../../../ComponentInterface";
import { configEnabledAtom, smetaStore } from "../../../../atoms";
import { tokenProcessingTest } from "../../../TokenProcessing/TokenProcessing";

export async function accountsAnalyticGrid(grid: createGrid, source: createRecordSource, props, data) {
  source.onHandleRequest = handleAnalyticRequest(props);

  const changeGridStyles = async (table: HTMLGridTableElement) => {
    for (const cell of Array.from(table.querySelectorAll<HTMLGridTableCellElement>(".grid-td"))) {
      const { fieldName } = cell.field;
      if (fieldName === "AnalyticID") {
        if (data.gridAccountPlanRef.current.grid.source.getFieldTextSync("ID") !== source.getFieldTextSync("AccountID"))
          cell.style.fontWeight = "bold";
        if (Number(source.getFieldTextSync("ID")) < 0) cell.style.fontStyle = "italic";
      }
    }
  };

  const analyticsInitialValueDropDownList = async () => {
    const json = await smetaAxios.get<{ Module?: string; ObjType?: string }>("GetInitialInfo", {
      prefix: Prefixes.acc,
      params: { ID: source.getFieldValueSync("AnalyticID") },
      loadMask: true,
    });
    if (json.Module && json.ObjType) {
      const objectValues = await getParamObjectValues(json.Module, json.ObjType);
      return objectValues.Items.map((item) => ({ id: item.id, label: item.text }));
    }
    return [];
  };

  const analyticsInitialValueEditButtonClick = async () => {
    const json = await smetaAxios.get<{ Module?: string; ObjType?: string }>("GetInitialInfo", {
      prefix: Prefixes.acc,
      params: { ID: source.getFieldValueSync("AnalyticID") },
      loadMask: true,
    });
    if (json.Module && json.ObjType) {
      const dialogParamsResponse = await getDialogParams({
        module: json.Module,
        objType: json.ObjType,
        objRef: source.getFieldValueSync("InitialValue"),
      });
      if (!dialogParamsResponse.Break) dialogParamsResponse.Break = "";
      if (!dialogParamsResponse.Token) dialogParamsResponse.Token = "HandleTable";
      tokenProcessingTest(dialogParamsResponse, {
        props: {
          onEdit: async (data) => {
            await grid.postSomeData("InitialValue", {
              id: data.tag,
              text: data.value,
            });
            await grid.postExicstedEditRec(true);
          },
        },
      });
    }
  };
  grid.canModify = (flag: number, column: ParsedColumn | undefined) => {
    if (!grid.localCanModify(flag, column, grid)) return false;
    const configEnabled = smetaStore.get(configEnabledAtom);
    const currentCode = source.getFieldTextSync("Code");
    const accountPlanCode = data.gridAccountPlanRef.current.grid.source.getFieldValueSync("Code");
    const isUserAnalytics = Number(source.getFieldTextSync("ID")) < 0;
    if (!configEnabled && !(data.canChangeUserAnalyticsRef.current && isUserAnalytics)) return false;
    switch (flag) {
      case mfEdit:
        return column?.fieldName === "Flags" || accountPlanCode === currentCode;
      case mfDelete:
        return accountPlanCode === currentCode;
      case mfInsert:
        return configEnabled;
    }
    return false;
  };
  grid.changeGridStyles = changeGridStyles;
  let columns = {
    title: [
      {
        fieldName: "AnalyticID",
        title: "Название",
        width: 120,
        level: 0,
        fieldInfo: {
          ...defaultFieldInfo,
          EditStyle: EditStyle.PickList + EditStyle.Ellipsis,
          Module: Prefixes.acc,
          DataType: ObjType.AccountAnalytic,
          options: getParamColumnsOptions(ParamSetOption.Fixed),
        },
      },
      {
        fieldName: "Flags",
        title: "Признаки",
        width: 120,
        level: 0,
        fieldInfo: {
          ...defaultFieldInfo,
          EditStyle: EditStyle.CheckList,
          // Values: [
          //   { label: "Основная", id: 1 },
          //   { label: "Вспомогательная", id: 2 },
          //   { label: "Информационная", id: 4 },
          // ],
        },
      },
      {
        fieldName: "InitialValue",
        title: "Значение по умолчанию",
        width: 150,
        level: 0,
        fieldInfo: {
          ...defaultFieldInfo,
          onDropDownList: analyticsInitialValueDropDownList,
          onEditButtonClick: analyticsInitialValueEditButtonClick,
          EditStyle: EditStyle.PickList + EditStyle.Ellipsis,
        },
      },
    ],
  };
  source.rights = getRightsData("-1");

  grid.setColumns(columns);
  grid.setImageFields(["ID"]);
  source.booksGetImage = (value, field) => {
    if (Number(value) < 0) return 29;
    return "";
  };
  await source.open();
  await grid.setSource(source);
  if (props.ID) {
    await grid.refreshSource(props.ID);
  } else await grid.refreshSource();

  if (data.setSelectedRecord) {
    source.onRecordIndexChanged = async function (source) {
      data.setSelectedRecord(source.getFieldTextSync("ID"));
    };
    data.setSelectedRecord(source.getFieldTextSync("ID"));
  }
  if (data.onMultiSelectChange) {
    grid.onMultiSelectChange = function () {
      data.onMultiSelectChange();
    };
  }
  await grid.updateGridSize();
}

export const handleAnalyticRequest = (props: {
  SectionID?: string | number;
  GroupID: string;
  shouldAddUserAnalyticRef: RefObject<boolean>;
}) => {
  return (request) => {
    const params = new Map();
    params
      .set("prefix", Prefixes.acc)
      .set("comand", "HandleAnalyticTable")
      .set("ObjType", "-1")
      .set("SectionID", props.SectionID)
      .set("GroupID", props.GroupID);
    if (props.shouldAddUserAnalyticRef.current) {
      params.set("User", "1");
      props.shouldAddUserAnalyticRef.current = false;
    }
    return AxiosRequest(true, params, request);
  };
};
